// extracted by mini-css-extract-plugin
module.exports = {"ads__image":"Ads-module--ads__image--1J4XR"};